import { render, staticRenderFns } from "./LoginAccountComponent.vue?vue&type=template&id=56423144&"
import script from "./LoginAccountComponent.vue?vue&type=script&lang=js&"
export * from "./LoginAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginAccountComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports